import React from 'react';
import { Typography } from '@mui/material';
import { OrganiztionsData } from '@Src/_basic/object/AccountRightType';

interface Props {
  row: OrganiztionsData;
}
export default function IndexColumnFormatter(props: Props) {
  const { row } = props;
  return <Typography variant="inherit">{row.index}</Typography>;
}
